<template>
  <div class="list sell shipCsv">
    <div v-if="load">
      <vue-loading style="position: fixed;z-index: 100;left: 25%;" type="spin" color="#333" :size="{ width: '50%', height: '50%' }"></vue-loading>
      <div class="over" style="opacity: 0.7;width: 100%;height: 100%;background: #fefefe;position: fixed;top: 0;left: 0;z-index: 99;"></div>
    </div>
    
    <div class="auctionRegister">
      <h1 class="topTitle">取引中商品管理</h1><div style="display:none;">{{ modalItems }}</div>
      
      <div class="container">
        
        <div class="outer-menu">
                <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox" />
                <div class="hamburger" :class="{ searchIcon: !isShowSerchBox}" @click="isShowSerchBox = !isShowSerchBox">
                    <div v-if="isShowSerchBox"></div>
                </div>
                <div class="menu">
                    <div class="searchArea">
                        <div class="searchBox">
                            <h2 class="itemTitle">検索</h2> 
                            <ul>
                                <li>
                                <label for="itemName">出品ID:</label>
                                <input type="text" placeholder="出品ID" id="sellId" v-model="serchItem.sellId" tabindex="1"/>
                            </li>
                            <li>
                                <label for="itemName">ユーザー名:</label>
                                <select class="sltBox" v-model="serchItem.userId">
                                    <option value="" disabled selected hidden>選択してください</option>
                                    <option v-for="item in userList" :value="item.USER_ID" :key="item.USER_ID">
                                        {{ item.USER_NAME }}
                                    </option>
                                </select>
                                
                            </li>
                            <li class="serchDateBox">
                                <label for="serchIsSelled">未出力売買のみ表示:</label><br>
                               <input type="checkbox" v-model="serchItem.isSelled" id="serchIsSelled" >
                               <label class="checkbox03" for="serchIsSelled"></label>
                            </li>
                        </ul>
                        <div class="btnBox">
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, clear()">クリア</button>
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, serch()">検索</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="ww">
            <div class="scrollbar" id="scrollbar"><div id="scrollInner" class="inner" @scroll.passive="onScroll"></div></div>
          </div>
          <div id="scrollbox" class="sellersV item-wrap scrollbox">
              <table id="csvTable" class="itemTable inner-content" style="border-collapse: separate;">
                <tr>
                        <th class="titleChk">確認</th>
                        <th class="listTitle">操作</th>
                        <th class="listTitle">出品者名</th>
                        <th class="listTitle">ステータス</th>
                        <th class="listTitle" >売買日</th>
                        <th class="titleChk">コメント数</th>
                        <th class="listTitle" >商品ページへ</th>
                        <th class="listTitle" >バーコード表示</th>
                      </tr>
                      <tr v-for="(item, i) in getItems" :key="i">
                        <td class="listItem">
                          <!-- 確認 -->
                          <input type="checkbox" v-model="item.DONE_FLG" :id="'serchIsSelled' + i" @change="chkChange(item)">
                          <label class="checkbox03" :for="'serchIsSelled' + i"></label>
                        </td>
                        <!-- 操作 -->
                        <td class="listItem"><button class="btn remove" style="min-width:0;" @click="modal(item)">操作する</button></td>
                        <!-- 出品者名 -->
                        <td class="listItem">{{ item.USER_NAME }}</td>
                        <!-- ステータス -->
                        <td class="listItem" >{{ item.status }}</td>
                        <!-- 売買日 -->
                        <td class="listItem" >{{ item.SELL_DATE }}</td>
                        
                        <!-- コメント件数 -->
                        <td class="listItem">{{ item.COM_COUNT }}件</td>
                        <!-- 商品ページリンク -->
                        <td class="listItem" ><a :href="'https://paypayfleamarket.yahoo.co.jp/item/'+item.SELL_ID" target="_blank" rel="noopener noreferrer" class="link">商品ページ</a></td>
                        <!-- バーコード表示ボタン -->
                        <td class="listItem"><button :disabled="item.SHIPPING_NOTIFICATION!=1 && item.SHIPPING_NOTIFICATION!=2" class="btn remove" style="min-width:0;" @click="barcode(item)">表示する</button></td>
                      </tr>
              </table>
          </div>
        <div class="item-wrap" style="overflow: hidden;">
          <div class="pdgTop10">
              <vuejs-paginate
              :page-count="getPaginateCount"
              :prev-text="'<'"
              :next-text="'>'"
              :click-handler="paginateClickCallback"
              :container-class="'pagination justify-content-center'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-class="'page-item'"
              :prev-link-class="'page-link'"
              :next-class="'page-item'"
              :next-link-class="'page-link'"
              :first-last-button="true"
              :first-button-text="'<<'"
              :last-button-text="'>>'"
              ></vuejs-paginate>
          </div>
          <div class="overlay" v-show="isShow">
            <div class="modalodal">
              <div class="swal2-popup swal2-modal swal2-show" style="display: grid;width: 100%;padding: 5px;height: 600px;overflow: auto;">
                <table class="itemTable">
                  <tr>
                    <th class="listTitle name" style="width: 30%;"> コメント送信者名 </th>
                    <th class="listTitle name" style="width: 30%;"> コメント送信日時 </th>
                    <th class="listTitle com"> コメント </th>
                  </tr>
                  <tr v-for="it in modalItems.coms">
                    <td>{{ it.USER_NAME }}</td>
                    <td>{{ it.COMMENT_DATE }}</td>
                    <td>{{ it.COMMENT }}</td>
                  </tr>
                </table>
                <div>
                  <h5 @click="mdoalType = 'msg'">メッセージを返信する</h5>
                  <div v-show="mdoalType == 'msg'"><textarea rows="5" v-model="postItem.com"></textarea><button class="btn modif" @click="setComment">返信する</button></div>
                </div>
                <div>
                  <h5 @click="mdoalType = 'hassou'" v-show="modalItems.STATUS == 'WAIT_FOR_SELLER_SHIP' && (modalItems.SHIPPING_NOTIFICATION == null || modalItems.SHIPPING_NOTIFICATION == '1')">発送通知をする</h5>
                  
                  <div v-show="mdoalType == 'hassou'">
                    <div v-show="modalItems.SHIPPING_NOTIFICATION == null">
                      <input type="text" placeholder="商品名" v-model="postItem.SHIP_NAME">
                      <h6 id="pShipMethod" class="itemLable">配送方法</h6>
                    
                      <select class="sltBox" v-model="postItem.SHIP_METHOD">
                          <option value="" disabled selected hidden>選択してください</option>
                          <option v-for="item in PShipMethodList" :value="item.CODE_ID" :key="item.CODE_ID">
                              {{ item.CODE_NAME }}
                          </option>
                      </select>
                    </div>
                    
                    <button v-show="modalItems.SHIPPING_NOTIFICATION == null" class="btn modif" @click="editItem('0', 'get_barcode')">バーコードを取得する</button>
                    <button v-show="modalItems.SHIPPING_NOTIFICATION == '1'" class="btn modif" @click="editItem('2', 'setInfo')">発送通知する</button>
                  </div>
                </div>
                
                <div class="swal2-actions"><button class="swal2-cancel swal2-styled" @click="reModal">戻る</button></div>
              </div>
            </div>
          </div>
          <!-- バーコード表示用モーダル -->
          <div class="overlay" v-show="isBarcode">
            <div class="modalodal" style="background-color: #fff;">
              <div style="background-color: #fff; width:80%;height:80%;">
                <span>発送場所</span>
                <select class="sltBox" v-model="select_img">
                    <option value="" disabled selected hidden>選択してください</option>
                    <option v-for="item in barcodeList" :value="item.image" :key="item.from">
                        {{ item.from }}
                    </option>
                </select>
                <div v-show="select_img != ''">
                  <img :src="'data:;base64,'+ select_img" style="width: 300px;">
                </div>
                <div class="swal2-actions"><button class="swal2-cancel swal2-styled" @click="reBarcode">戻る</button></div>
              </div>
            </div>
          </div>
        </div>

        <div class="btnBox subArea">
          <button class="btn repage" @click="returnPage">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import VueJsPaginate from "vuejs-paginate";
import { VueLoading } from 'vue-loading-template'
import Encoding from 'encoding-japanese';
import Datepicker from "vuejs-datepicker";
import { ja } from "vuejs-datepicker/dist/locale";

import {userRepository} from '@/Repositories/userRepository.js';
import {code_repository} from '@/Repositories/m002_p_code_repository.js'
import {tran_coms_repository} from '@/Repositories/u006_p_tran_coms_repository.js'
import {tran_recoms_repository} from '@/Repositories/u007_p_tran_recoms_repository.js'
import {tran_info_repository} from '@/Repositories/u008_p_tran_info_repository.js'
import {w_category_repository} from '@/Repositories/u012_p_w_category_repository.js'
import {ship_code_repository} from '@/Repositories/u015_p_ship_code_repository.js'
export default {
  data() {
    return {
      /******************
       * Datepicker設定
       ******************/
      ja: ja,
      disabledDates: {
        from: new Date(),
      },
      /******************
       * 検索用
       ******************/
      serchItem:{
        sellId:null,
        userId:null,
        isSelled:false
      },
      userInfo:{},
      isShowSerchBox:false,
      userList:[],
      /******************
       * 表示・非表示フラグ
       ******************/
      isShow:false,
      tmp:'',
      load: false,
      isBarcode : false,
      /******************
       * リスト
       ******************/
      codeList:[],
      PShipMethodList:[],
      barcode_name_list:[],
      barcodeList:[],
      /******************
       * 出力
       ******************/
      items:[],
      categoryList:[],
      postItem:[],
      modalItems:[],
      mdoalType:'',
      currentPage: 1,
      perPage: 20,
      select_img : '',
    }
  },
  components: {
    "vuejs-paginate": VueJsPaginate,
    Datepicker,
    VueLoading,
  },
  methods: {
    onScrollXTopBar(e) {
      document.getElementById("content").scrollTo(e.target.scrollLeft, 0);
    },
    onScrollXContent(e) {
      document.getElementById("topbar").scrollTo(e.target.scrollLeft, 0);
    },
    
    reModal(){
      let vm = this;
      vm.modalItems = {};
      vm.postItem = {};
      vm.isShow = false;
    },
    setComment() {
      let vm = this;
      vm.tmpComList;
      var e = vm.userList[0].PARENT_ID;

      tran_recoms_repository.upd({
        USER_ID: vm.postItem.USER_ID,
        DONE: "0",
        SELL_ID: vm.postItem.SELL_ID,
        PARENT_ID: e,
        COMMENT: vm.postItem.com
      }).then(e=>{
        vm.postItem = {},
        vm.$swal("コメント返信登録しました。", "", "success").then(e=>{
          vm.modalItems = {};
          vm.postItem = {};
          vm.isShow = false;
          }
          )
      }
      )
  },
  editItem(hassou, type) {
      let vm = this;
      var post = {...vm.modalItems};
      delete post.USER_NAME; 
      delete post.SEND_FLG; 
      delete post.coms; 
      delete post.status; 
      var i = vm.userList[0].PARENT_ID;
      post.SHIPPING_NOTIFICATION = hassou;
      tran_info_repository.upd(post).then(t=>{
        vm.modalItems = {};
        vm.postItem = {},
        vm.$swal("登録しました。", "", "success").then(t=>{
              s.isModal = !1
          })
      })
  },
  barcode(item){
    let vm = this;
    vm.isBarcode = true;
    ship_code_repository.get(item.SELL_ID).then(res=>{
      var data = res.data;
      var json = JSON.parse(data.SHIP_CODE);
      vm.barcodeList = json.shipCodeImageList;
    });
  },
  reBarcode(){
    let vm = this;
    vm.isBarcode = false;
    vm.barcodeList = [];

  },
    modal(item){
      let vm = this;
      vm.isShow = true;
      var shipMethods = vm.codeList.filter(x=> x.CODE_TYPE == 'shipMethod_'+item.SHIP_METHOD_VENDOR);
      tran_coms_repository.get(item.SELL_ID).then(r=>{
          vm.modalItems = item;
          vm.postItem = item;
          vm.modalItems.coms = r.data;
          vm.PShipMethodList = shipMethods;
        });
    },
    paginateClickCallback (pageNum) {
        this.currentPage = Number(pageNum);
    },
    returnPage(){
      let vm = this;
        vm.$router.back();
    },
    getCategory(){
        w_category_repository.get(this.userInfo.USER_ID).then(res=>{
            this.categoryList = res.data;
        })
    },
    getCategoryName(id){
        var category = this.categoryList.find(x=> x.ID == id);
        if(category) return category.CATEGORY_NAME
        else return '';
    },
    getCode(){
      let vm = this;
      code_repository.get()
        .then((res)=>{
          vm.codeList = res.data;
        });
    },
    chkChange(item){
      let vm = this;
      var post = {...item};
      delete post.USER_NAME; 
      delete post.SEND_FLG; 
      delete post.coms; 
      delete post.status; 
      tran_info_repository.upd(post).then(res=>{
        vm.$swal("完了フラグを変更しました。", "", "success")
      })
    },
    init(){
      let vm = this;
      vm.userInfo = vm.$functions.getSStorage('userInfo');
      userRepository.methods.getChild().then(res=>{
          vm.userList = res.data;
          vm.getCategory();
          vm.getCode();
          tran_info_repository.get(res.data[0].PARENT_ID).then(r=>{
          for(var i = 0; i < r.data.length; i++){
            var ia = res.data.find(x=> x.USER_ID == r.data[i].USER_ID);
            if(!ia) continue;
            r.data[i].USER_NAME = ia.USER_NAME;
            var status = "";
            switch(r.data[i].STATUS){
              case 'WAIT_FOR_SELLER_SHIP':
                status = '発送待ち';
                break;
              case 'SELLER_SHIPPED':
                status = '評価待ち';
                break;
              case 'COMPLETE':
                status = '評価済';
                break;
            }
            r.data[i].status = status;
            r.data[i].DONE_FLG = r.data[i].DONE_FLG == '1';
          }
          vm.items = r.data.filter(x=> x.USER_NAME != null).sort(function(a, b) {
            return (a.SELL_DATE > b.SELL_DATE) ? -1 : 1; 
          });
        })
      })
    },
  },
  computed:{
        getPaginateCount: function () {
            return Math.ceil(this.items.length / this.perPage);
        },
        getItems () {
          if(this.items.length == 0) return;
          let start = (this.currentPage - 1) * this.perPage;
          let end = this.currentPage * this.perPage;
         
            return this.items.slice(start, end);
          }
    },
    created:function(){
      let vm =this;
      vm.init();
  },
  mounted: function() {
    $(function() {
      'use strict';
      $("#scrollbar, #scrollbox").on('scroll', function() {
        
        var tableWidth = $('#csvTable').width() + 20;
        if ( $(this).attr('id') === 'scrollbar' ) {
          $('#scrollInner').css('width',tableWidth);
          
          console.log($('#scrollbox tr th:nth-child(4)').width());
          $('#scrollbox').scrollLeft($(this).scrollLeft());
        } else {
          $('#scrollInner').css('width',tableWidth);
          $("#scrollbar").scrollLeft($(this).scrollLeft());
        }
      });
      
    });
  },
  validations:{
    
  
  }
};
</script>

<style lang="scss">
@import "../style/sell.scss";
@import "../style/shipCsv.scss";

@import "../style/auctionRegister.scss";
.sellersV{
    overflow: auto;
    width: 100%;
    max-height: 800px;
}
.sellersV table{
    margin: 0;
    border-spacing: 0;
}
.sellersV th{
    white-space: nowrap;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    left: 0;
    min-width: 0 !important;
}
.sellersV td{
    white-space: nowrap;
}
.scrollbar {
  width: 100%;
  height: 10px;
  overflow-x: scroll;
  overflow-y: hidden;
}
.scrollbar .inner {
  width: 3700px;
  height: 1px;
}
.scrollbox {
  width: 100%;
  margin-top: 5px;
  overflow-x: scroll;
}
.scrollbox .inner {
  width: 3500px;
  height: 200px;
  margin-bottom: 5px;
  background-color: #F9F8F6;
}
.scrollbox .txt {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
}
/* スクロールバーのスタイル */
.scrollbar::-webkit-scrollbar,
.scrollbox::-webkit-scrollbar {
  height: 10px;
}
.scrollbar::-webkit-scrollbar-track,
.scrollbox::-webkit-scrollbar-track {
  border-radius: 5px;
}
.scrollbar::-webkit-scrollbar-thumb,
.scrollbox::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #e7e7e7;
}

// #scrollbox tr th:nth-child(1), #scrollbox tr th:nth-child(2) , #scrollbox tr th:nth-child(3) , #scrollbox tr th:nth-child(4) , #scrollbox tr th:nth-child(5) ,
// #scrollbox tr td:nth-child(1), #scrollbox tr td:nth-child(2) , #scrollbox tr td:nth-child(3) , #scrollbox tr td:nth-child(4) , #scrollbox tr td:nth-child(5) {
//     position: sticky;
//     z-index:5 !important;
// }
// #scrollbox tr td:nth-child(1), #scrollbox tr td:nth-child(2) , #scrollbox tr td:nth-child(3) , #scrollbox tr td:nth-child(4) , #scrollbox tr td:nth-child(5) {
//   background-color: #fff;
//   z-index:4 !important;
// }
#scrollbox tr td{
  border: solid 0.5px #5d8ab5;
}
// #scrollbox tr th:nth-child(1), #scrollbox tr td:nth-child(1){
//   left:0;
// }
</style>